// extracted by mini-css-extract-plugin
module.exports = {"FrontPage":"homePage_FrontPage__1Ncxw","socialContainer":"homePage_socialContainer__XT6iG","startText":"homePage_startText__3k6si","socialLinks":"homePage_socialLinks__3ivXx"};